import React from "react";
import Contentt from "../../img/Contentt.jpeg";
const Content = () => {
  return (
    <div className="a-content">
      <div className="c-left">
        <h1 className="key">key skills</h1>
        <div className="c-cardd">
          <div>
            <div className="card text-white bg-success mb-3">
              <div className="card-body">
                <p className="card-text manja">
                  Comprehensive knowledge of primary development languages for
                  instance C, C++, JAVA, python and special talent of writing
                  highly competent programs.
                </p>
              </div>
            </div>
            <div className="card text-white bg-secondary mb-3">
              <div className="card-body">
                <p className="card-text">
                  Skills- Responsive Design,Mobile Development,Data
                  visualization.Able to understand and implement modern
                  operating systems and great experience of their
                  troubleshooting.
                </p>
              </div>
            </div>
            <div className="card text-white bg-primary mb-3">
              <div className="card-body">
                <p className="card-text">
                  <p> Technologies</p>
                  <p>Javascript,HTML5,CSS3,Bootstrap,React.js.</p>
                  <p>Good communication skills.</p>
                  <p>Mathematics & Problem-solving</p>
                  <p>positive and Flexible mental attitude</p>
                  <p>keen observation and strong memory</p>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="c-right">
        <div className="c-card bg"></div>

        <img src={Contentt} alt="" className="c-img" />
      </div>
    </div>
  );
};

export default Content;
